module.exports = __webpack_public_path__ + "img/Panasonic (1).3be66c4b.png";